<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="设置" size="40%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">


        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">

                <el-form-item label="加急订单停止时间" label-width="180px">
                  <el-date-picker
                    v-model="formData.companyUrgentPartsStopArray"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>


                <el-form-item label="加急订单每日停止时点" label-width="180px">
                  <el-time-picker
                    is-range
                    value-format="HH:mm:ss"
                    v-model="formData.companyUrgentPartsStop"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围">
                  </el-time-picker>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="doCheck">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
import api from "@/api/projectApi";
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue"
import DictSelect from "@/components/formItem/dictSelect.vue";

export default {
  inject: ['reload'],
  name: 'companySettingsDialog',
  props: ['multi', 'param'],
  components: {
    checkSubjectSearch,
    DictSelect
  },
  created() {

  },
  data() {
    return {
      show3: false,
      dataId: '',
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      drawer: true,
      formData: {
        companyUrgentPartsStopArray: null,
        companyUrgentPartsStop: null,
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$http.post(api.fwpttenant.getCurrentCompanyInfoUrl, {}).then(res => {
        let data = res.data.data
        this.formData.id = data.id
        this.formData.companyUrgentPartsStop = data.companyUrgentPartsStop
        // if (data.companyUrgentPartsStop) {
        //   let t = this.formatDate(new Date(), 'yyyy-MM-dd');
        //   let strings = data.companyUrgentPartsStop.split('|')
        //   this.formData.companyUrgentPartsStop = [new Date(t + " " + strings[0]), new Date(t + " " + strings[1])]
        // }
        if (data.companyUrgentPartsStopBegin != null && data.companyUrgentPartsStopEnd != null) {
          this.formData.companyUrgentPartsStopArray = [data.companyUrgentPartsStopBegin, data.companyUrgentPartsStopEnd]
        }
      })
    },


    doCheck() {
      this.$mask.open()
      // let a =
      // let b =
      // let temp = null
      // if (this.formData.companyUrgentPartsStopArray != null && this.formData.companyUrgentPartsStopArray.length > 0) {
      //   let splice = (this.formData.companyUrgentPartsStop[0] + '').splice(' ');
      //   if (splice.length == 1) {
      //     temp.push(splice[0])
      //   } else {
      //     temp.push(splice[1])
      //   }
      //
      //   let splice1 = (this.formData.companyUrgentPartsStop[1] + '').splice(' ');
      //   if (splice1.length == 1) {
      //     temp.push(splice1[0])
      //   } else {
      //     temp.push(splice1[1])
      //   }
      // }

      this.$http.post(api.fwpttenant.updateCompanyUrgentPartsStopUrl, {
        id: this.formData.id,
        companyUrgentPartsStopArray: this.formData.companyUrgentPartsStopArray,
        companyUrgentPartsStop: this.formData.companyUrgentPartsStop
      }).then(res => {
        this.$message.success('操作成功')
        this.$mask.close()
        this.handleClose()
      }).catch(() => {
        this.$mask.close()
      })
    },

    /**
     * 格式化函数 ， 给日期格式化
     * date为 new Date()对象， fmt为 'yyyy-MM-dd hh:mm:ss'的格式
     */
    formatDate(date, fmt) {
      //获取年份
      if (/(y+)/.test(fmt)) {
        // 把数字变成字符串
        let dateY = date.getFullYear() + "";
        //RegExp.$1 在判断中出现过，且是括号括起来的，所以 RegExp.$1 就是 "yyyy"
        fmt = fmt.replace(RegExp.$1, dateY.substr(4 - RegExp.$1.length));
      }

      //获取其他
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },

    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },

    cancelForm() {
      this.drawer = false;

    },
    handleClose() {
      this.drawer = false;
      this.$emit('update:visiable', this.drawer)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}
</style>
